import { Col, Divider, Form, Row } from 'antd';
import { FormCheckBox } from 'presentation/components/form/FormCheckBox.component';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import { commonHelpers } from 'utilities/helpers';
import { ItemBox } from '../../CU-015-01/components/ItemBox';
import { StepProps } from '../props/StepProps';
import { ItemView } from './ItemView';

export const StepViewThree = ({ data, masterData }: StepProps) => {
    const navigate = useNavigate();
    const redirectCU05802 = () => {
        const param = {
            purchasePrice: data?.purchasePrice,
            purchaseOfferId: data?.purchaseOfferId,
            procedureId: data?.procedureId,
            loanUseStatus: data?.loanUseStatus,
        };
        navigate(
            `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_058_02}/${data?.simId}?${commonHelpers.generateQueryString(param)}`,
        );
    };
    return (
        <>
            <Row className="min-w-min">
                <div className="w-full mb-[32px]">
                    <Row gutter={[0, 12]} className="mt-[12px]">
                        <Col span={24} className="pl-[12px]">
                            ご契約日時等についての詳細や、仲介手数料等の支払方法の詳細につきましては、当社スタッフより3営業日以内にメールにてご連絡差し上げます。
                        </Col>
                        <Col span={12}  className="ml-[12px]">
                            <FormCheckBox
                                name="accept_description"
                                required
                                disabled
                                defaultValue="10"
                                options={[
                                    {
                                        value: '10',
                                        label: '理解しました',
                                    },
                                ]}
                                showErrorMessage={false}
                                className="mb-0"
                            />
                        </Col>
                    </Row>
                       <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <ItemBox
                                label="契約予定日"
                                value={data?.scheduleContactDate}
                                type="date"
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12} className="pr-[12px]">
                            <ItemBox
                                label="決済予定日"
                                value={data?.scheduleFinalPaymentDate}
                                type="date"
                            />
                        </Col>
                    </Row>
                </div>
                <div className="w-full mb-[32px]">
                    <span className="content-step-form heading-step-form">売買代金</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="my-[12px]">
                        <Col span={12} className="pr-[12px]">
                            <ItemBox
                                label="購入価格"
                                value={data?.purchasePriceExcludingBrokerageFee}
                                type="number"
                                suffix="円"
                            />
                        </Col>
                        <Col span={12} className="pr-[12px]">
                            <ItemBox
                                label="仲介手数料"
                                value={data?.brokerageFeeSpecificTreat ?? ''}
                                type="number"
                                suffix="円"
                                defaultvalue={0}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="my-[12px]">
                        <Col span={12} className="pr-[12px]">
                            <ItemBox
                                label="代金総額"
                                value={data?.totalPrice}
                                type="number"
                                suffix="円"
                            />
                        </Col>
                         <Col span={12} className="pr-[12px]">
                                <ItemBox
                                    label="自己資金"
                                    value={data?.personalFunds}
                                    type="number"
                                    suffix="円"
                                />
                        </Col>
                    </Row>
                </div>
                {data?.loanUseStatus != '10' && (
                    <div className="w-full mb-[32px]">
                        <span className="content-step-form heading-step-form">代金支払内訳</span>
                        <Divider className="mb-[24px] my-1" />
                        <Row className="my-[12px]">
                            <Col span={12} className="pr-[12px]">
                                <ItemBox
                                    label="現金"
                                    value={data?.personalFunds}
                                    type="number"
                                    suffix="円"
                                    suffixLinkText="修正"
                                    onClickLink={redirectCU05802}
                                />
                            </Col>
                            <Col span={12} className="pr-[12px]">
                                <ItemBox
                                    label="ローン金額"
                                    value={Number(data?.purchasePriceExcludingBrokerageFee) - Number(data?.personalFunds)}
                                    type="number"
                                    suffix="円"
                                    suffixLinkText="修正"
                                    onClickLink={redirectCU05802}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} className="pr-[12px]">
                                <ItemBox
                                    label="ローン期間"
                                    value={`${data?.repaymentPeriod ?? '0'}年`}
                                    type="text"
                                />
                            </Col>
                            <Col span={12} className="pr-[12px]">
                                <ItemBox
                                    label="ローン金利"
                                    value={`${commonHelpers.formatMoney(data?.interestRate ?? '0')}％`}
                                    type="text"
                                />
                            </Col>
                        </Row>
                    </div>
                )}

                <div className="w-full mb-[32px]">
                    <span className="content-step-form heading-step-form">取引目的</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="my-[12px]">
                        <Col span={12}>
                            <ItemView
                                options={
                                    masterData?.[
                                        MASTER_CATEGORY_LIST.DEAL_PURPOSE_TYPE_CLASSIFICATION
                                    ]
                                }
                                label="取引目的"
                                value={data?.dealPurposeType}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12}>
                            <ItemView
                                label="その他目的"
                                value={data?.dealPurposeOthers}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={24}>
                            <ItemView
                                label="キャンペーンコード（任意）"
                                value={data?.campaignCode}
                                labelClassName="content-step-form label-step-form"
                                defaultValue={'なし'}
                            />
                        </Col>
                    </Row>
                </div>
            </Row>
        </>
    );
};
